<div id="choose-listing" class="choose-listing">
    <main class="main-container">
        <div class="content">
            <div class="row text-center mb-5 mb-md-0">
                <div class="col-12">
                    <h1 class="welcome">
                        TYPE OF LISTING
                    </h1>
                </div>
                <div class="col-12">
                    <h2 class="listing-as">
                        I wish to list this property with a:
                    </h2>
                </div>
            </div>
            <div class="row text-center mt-4 align-items-stretch">
                <div class="col-12 col-md-6 d-flex flex-column align-items-center mb-5 mb-md-0">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <h3 class="seller-type">PLANNING REPORT</h3>
                        <h1 class="seller-number">1</h1>
                        <p class="seller-description">
                            Seller signed exclusive mandate & Instruction letter.
                        </p>
                        <button class="button mt-auto" type="button"
                            (click)="onProceed('/sell-your-property/overview', 'broker-agent','PLANNING REPORT')">Proceed</button>
                    </div>
                </div>
                <div class="col-12 col-md-6 d-flex flex-column align-items-center">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <h3 class="seller-type">LEAFLET</h3>
                        <h1 class="seller-number">2</h1>
                        <p class="seller-description">
                            Broker/Agent prepare one-pager property brief.
                        </p>
                        <button class="button mt-auto" type="button"
                            (click)="onProceed('/sell-your-property/steps', 'broker-agent','LEAFLET')">Proceed</button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
